const DEFAULT_PORTAL_ROUTE = '/pc'
const ADMIN_LOGIN_ROUTE = '/login'
const ADMIN_ENTRY_ROUTE = '/admin'

function isPortalRoute(path) {
  return path === '/' || path === DEFAULT_PORTAL_ROUTE || String(path || '').indexOf(`${DEFAULT_PORTAL_ROUTE}/`) === 0
}

function isPortalEntry(path) {
  return path === '/'
}

function isAdminLoginRoute(path) {
  return path === ADMIN_LOGIN_ROUTE
}

function isPublicRoute(path) {
  return isPortalRoute(path) || isAdminLoginRoute(path)
}

function getDefaultRoute() {
  return DEFAULT_PORTAL_ROUTE
}

module.exports = {
  DEFAULT_PORTAL_ROUTE,
  ADMIN_LOGIN_ROUTE,
  ADMIN_ENTRY_ROUTE,
  isPortalRoute,
  isPortalEntry,
  isAdminLoginRoute,
  isPublicRoute,
  getDefaultRoute
}
